// Copyright (c) 2022 by Move Closer

import { ArticlesTeaserConfig } from './ArticlesTeaser.contracts'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const ARTICLES_TEASER_KEY = 'ArticlesTeaserModule'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const ARTICLES_TEASER_CONFIG_MAP: ArticlesTeaserConfig = {
  buttonIcon: null,
  carouselConfig: {
    autoplay: false,
    infinite: false,
    slidesToScroll: 1,
    responsive: {
      mobile: {
        perPage: 2,
        hasButtons: true,
        hasPagination: false
      },
      desktop: {
        perPage: 1,
        hasButtons: false,
        hasPagination: false,
        swipe: false
      }
    }
  }
}
